export default __webpack_public_path__ + "static/assets/45151614535c7c8d22c366cc825b9175.svg";